import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { LoaderService } from "src/app/loader/loader.service";
import { environment } from "src/environments/environment";
import { Payment } from "../models/payment";
import { ChargesStoreService } from "../services/charges-store.service";
import { ChargesService } from "../services/charges.service";

@Component({
  selector: "app-charges-details",
  templateUrl: "./charges-details.component.html",
  styleUrls: ["./charges-details.component.scss"],
})
export class ChargesDetailsComponent implements OnInit {
  env;
  totalDesconto: number;
  payment: Payment;
  formasDePagamento = [];
  writeOffsPage = 1;
  writeOffsPageSize = 10;
  writeOffsCollectionSize = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private chargesService: ChargesService,
    private loaderService: LoaderService,
    public chargesStore: ChargesStoreService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getPayment(this.env.selected.cnpj, this.route.snapshot.paramMap.get("id"));
  }

  async getPayment(cnpj: string, id: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando cobrança...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.payment = await this.chargesService.getPayment(cnpj, id).toPromise();

    this.formasDePagamento =
      this.payment.baixas.map(baixa => ({
        valor: baixa.valor_titulo,
        forma_pagamento: this.chargesStore.getPaymentType(baixa.forma_pagamento),
        tipo: baixa.forma_pagamento,
        bandeira: baixa.bandeira,
      })) || [];

    this.writeOffsCollectionSize = this.payment.baixas.length;

    this.totalDesconto = this.payment.baixas.reduce((total, baixa) => total + (baixa.valor_desconto || 0), 0);
    console.log("Payment Details:", this.totalDesconto);
    loader.dismiss();
  }

  formatDate(date: string): string {
    if (!date) return "";

    if (date.length === 8 && /^\d+$/.test(date)) {
      return `${date.substr(6, 2)}/${date.substr(4, 2)}/${date.substr(0, 4)}`;
    }

    const m = moment(date);
    return m.isValid() ? m.format("DD/MM/YYYY") : date;
  }

  goCharges(): void {
    this.router.navigateByUrl(`/charges/${this.env.selected.cnpj}`);
  }

  goBack(): void {
    this.router.navigateByUrl(`/chargesmodule/${this.env.selected.cnpj}`);
  }
}
